module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isDoingAutoLogin),
      expression: "isDoingAutoLogin"
    }],
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("自动登录中...")]), _vm._v(" "), _c('form', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isDoingAutoLogin),
      expression: "!isDoingAutoLogin"
    }],
    staticClass: "form",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submit();
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('my-input', {
    ref: "username",
    staticClass: "the-input",
    attrs: {
      "wide": "",
      "required": "",
      "no-required-sign": "",
      "blur-check": "",
      "placeholder": "手机号"
    },
    model: {
      value: (_vm.username),
      callback: function($$v) {
        _vm.username = $$v
      },
      expression: "username"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('my-input', {
    ref: "password",
    staticClass: "the-input",
    attrs: {
      "type": "password",
      "wide": "",
      "required": "",
      "no-required-sign": "",
      "blur-check": "",
      "placeholder": "密码"
    },
    model: {
      value: (_vm.password),
      callback: function($$v) {
        _vm.password = $$v
      },
      expression: "password"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('button', {
    staticClass: "btn wide",
    on: {
      "click": function($event) {
        _vm.submit();
      }
    }
  }, [_vm._v("登录" + _vm._s(_vm.loading ? '...' : ''))])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "20px",
      "text-align": "left"
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        _vm.$router.go({
          name: 'register'
        })
      }
    }
  }, [_vm._v("注册")])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "100px",
      "text-align": "center"
    }
  }, [_c('span', {
    staticStyle: {
      "margin": "0 -50px",
      "font-size": "10px",
      "color": "#ccc"
    }
  }, [_vm._v("版本: " + _vm._s(_vm.rev))])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-10c4c680!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/login.vue
// module id = 303
// module chunks = 1